import { Box } from "@mui/material";
import { colors } from '../../Theme/tokens';

const NotificationIconBox = ({
  Icon,
  size = 36,
  iconSize = 24,
  bgColor = colors.background.iconBox,
  borderRadius = "7.58px",
  sx
}) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius,
        backgroundColor: bgColor,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...sx,
      }}
    >
      <Icon
        sx={{ width: iconSize, height: iconSize }}
      />
    </Box>
  );
};

export default NotificationIconBox;
